// extracted by mini-css-extract-plugin
module.exports = {"header":"i_GQ","body":"i_GR","coach":"i_GS","footer-legal":"i_GT"};